import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/Team.css';

const Team = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="team" className="team-section">
      <div className="section-container">
        <h2>{t.teamTitle}</h2>
        <p className="team-description">{t.teamDesc}</p>
        <p className="backers">{t.backers}</p>
        
        {/* Team members would go here - can be added later */}
        <div className="team-members">
          {/* Placeholder for team members */}
        </div>
      </div>
    </section>
  );
};

export default Team;